<template>
    <div>
        <codemirror :options="options" :class="'card'" v-model="tmplContent" @input="stringAnalysis" style="margin-bottom: 0"/>
        <div class="mb-3 flex-display">
            <div></div>
            <div class="font-weight-semibold ml-auto">
                <div class="text-right mt-2 mb-2">
                    <span class="font-weight-semibold" :class="totalTextCharCnt > maxCharCount?'text-danger':''">{{totalTextCharCnt}}  / {{maxCharCount}} character</span>
                </div>
                <div v-for="(message,index) in validationResult" :key="'codemirror'+index" class="text-right">
                    <span class="font-weight-semibold text-danger">{{message}}</span>
                </div>
            </div>
        </div>
        <legend v-if="params.length > 0" class="text-uppercase font-size-sm font-weight-bold">Parameters</legend>
        <div class="row">
            <div class="col" v-if="params.length > 0">
                <div class="row form-group mb-1" v-for="(param,index) in params" :key="param + '' + index">
                    <div class="input-group col">
                        <span class="input-group-prepend">
                            <span class="input-group-text">{{param.paramKey}}</span>
                        </span>
                        <select class="form-control" v-model="param.paramLen" :disabled="param.paramType === 'T' || param.paramType === 'M' || param.paramType === 'm' || param.paramType === 'H' || param.paramType === 'D' || param.paramType === 'C' || param.paramType === 'c'">
                            <option v-for="index in 160" :key="'paramCnt'+index">{{index}}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {codemirror,CodeMirror} from 'vue-codemirror'
    import 'codemirror/lib/codemirror.css'
    import contentEditorMixin from "@/config/mixin/contentEditorMixin";
    import CONST from '@/config/const/const'
    CodeMirror.defineMode('custommode', () => {
        return {
            token(stream, state) {
                // if (stream.match(/^%([1-9]{1,1})%/g)) {
                if (stream.match(CONST.REGEX.EDITOR)) {
                    return "style-param"
                } else {
                    stream.next()
                    return null
                }
            }
        }
    })
    export default {
        name: "SmsContentEditor",
        components: {
            codemirror
        },
        mixins:[contentEditorMixin],
        props: {
            rule: {
                type:String
            },
            value: {
                type:Object
            },
        },
        data() {
            return {
                regex:CONST.REGEX.STRING_ANALYSIS,
                params:[],
                validationResult: [],
                tmplContent:'',
                maxCharCount: 160,
                options: {
                    tabSize: 4,
                    mode: 'custommode',
                    theme: 'base16-dark',
                    lineNumbers: true,
                    line: true,
                    lineWrapping: true,
                },
            }
        },
        computed: {
            totalTextCharCnt: function() {
                return this.params.reduce((base,item) =>{
                    base += (item.duplParamCnt * item.paramLen)
                    return base
                },this.$filters.characterByte(this.tmplContent.replace(this.regex,'')))
            },
        },
        mounted() {
        },
        methods: {
            getCheckedLength:function(params,currKey) {
                return params.reduce((base, item) => {
                    if (item.paramKey === currKey) base += (Number(item.paramLen) - 1)
                    return base
                }, 1)
            },
            validator: function() {
                this.validationResult = []
                if(this.isParamsDuplicated(this.params.map(item=>item.paramKey))) this.validationResult.push('Parameter keys cannot be duplicated')
                if(this.params.length > this.value.paramCnt) this.validationResult.push('The maximum number of parameters is '+this.value.paramCnt)
                if(this.totalTextCharCnt === 0) this.validationResult.push('This input is required.')
                if(this.totalTextCharCnt > this.maxCharCount) this.validationResult.push('Number of characters cannot exceed 160 character')
                return this.validationResult
            },
        },
        watch: {
            'totalTextCharCnt': function() {
                this.validator()
            },
            'value': function(val) {
                this.changeData(val)
            },
        }
    }
</script>

<style scoped>

</style>
